<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 md10>
        <eimza-gate title="SMS Gönder">
          <v-container fluid>
            <v-layout row>
              <v-flex xs12 md12>
                <v-alert style="overflow-x: auto" type="warning">
                  <span>
                    HATIRLATMA!
                    <br>
                    Ticari SMS içeriklerinde;
                    firmalar için Mersis No, şahıs işletmelerinde ise;
                    Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
                    RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
                  </span>
                </v-alert>
                <v-form ref="form" lazy-validation>
                  <v-layout row wrap>
                    <v-flex md3 xs12>
                      <v-flex xs12>
                        <small>Grup seçmeden işlem yapamazsınız*</small>
                        <v-select
                          :items="data.groups"
                          :rules="[
                            $rules.selection('Grup Alanı'),
                            () => selected.length > 0 || 'Grup Alanında seçim yapmalısınız',
                          ]"
                          :item-text="(group) => `${group.name} (${group.contacts_count})`"
                          item-value="id"
                          :menu-props="{ maxHeight: '400' }"
                          label="Gruplar"
                          v-model="selected"
                          required
                          multiple
                        >
                          <template v-slot:prepend-item ref="select">
                            <v-list-item ripple @click="toggle">
                              <v-list-item-action>
                                <v-icon :color="selected.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>Hepsini Seç</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <senders-or-message-types
                          label="Gönderici Adları"
                          required
                          no-data-text="Aktif Gönderici Adı bulunmuyor"
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderici adı seçimi yapmalısınız' })]"
                          :default="original.sender"
                          :items="data.senders"
                          @on:model-update="(val) => { original.sender = val; }"
                        ></senders-or-message-types>
                      </v-flex>
                      <v-flex xs12>
                        <template-selector
                          label="Şablon Seçinizi"
                          :items="data.templates"
                          @on:template-selected="(val) => { msgBox = val.content; }"
                        ></template-selector>
                      </v-flex>
                      <v-flex xs12>
                        <senders-or-message-types
                          label="Tür"
                          required
                          :items="types"
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Mesaj türü seçimi yapmalısınız' })]"
                          :default="data.default_message_type"
                          item-text="text"
                          item-value="value"
                          @on:model-update="(val) => { original.message_type = val; }"
                        ></senders-or-message-types>
                      </v-flex>
                      <v-flex xs12>
                        <time-type
                          :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderim zamanı seçimi yapmalısınız' })]"
                          @type:update="(val) => (wTimeStat = val)"
                        ></time-type>
                      </v-flex>
                      <v-flex xs12 d-flex v-if="wTimeStat">
                        <date-month-picker
                          label="Gönderme Tarihi"
                          :disable-prev="true"
                          :rules="[$rules.required({ falseValues: [''], message: 'Tarih seçimi yapmalısınız' })]"
                          @on:date-selected="(val) => { date = val; dateSelected = true; }"
                        ></date-month-picker>
                      </v-flex>
                      <v-flex xs12 v-if="wTimeStat">
                        <time-picker
                          label="Gönderme Saati"
                          :valid="dateSelected"
                          :rules="[$rules.empty('Gönderme Saati')]"
                          @on:time-selected="(val) => { time = ` ${val}:00`; }"
                        ></time-picker>
                      </v-flex>
                      <v-flex xs12 v-if="$store.state.iys_status === 1">
                        <message-type @type="(val) => (original.message_content_type = val)"></message-type>
                      </v-flex>
                    </v-flex>
                    <v-flex md9 xs12>
                      <v-flex xs12 v-if="data.keys">
                        <button-keys
                          :keys="data.keys"
                          item-value="value"
                          @on:button-key="(val) => { this.msgBox += ` ${val}`; }"
                        ></button-keys>
                      </v-flex>
                      <v-flex xs12>
                        <sms-message
                          label="Mesajınız"
                          required
                          :rules="[
                            $rules.empty('Mesaj'),
                            (v) => original.message_type === 'turkce' ? v.length <= 877 || 'Maksimum karakter sayısı 882 olabilir.' : original.message_type === 'normal' || true,
                          ]"
                          :value="msgBox"
                          :c-message="msgBox"
                          :c-type="original.message_type"
                          rows="16"
                          @text:change="(val) => { this.msgBox = val; }"
                        ></sms-message>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
              <v-flex>
                <sms-confirmation
                  :context="confirmation.context"
                  :valid="confirmation.valid"
                  @on:disagree="() => { $trigger('setPluginDialog'); confirmation.valid = !confirmation.valid; }"
                  @on:agree="sendMessage"
                >
                  <template v-slot:activator>
                    <v-btn color="primary" block :loading="loading" @click="smsPreview">
                      Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                    </v-btn>
                  </template>
                </sms-confirmation>
              </v-flex>
            </v-layout>
          </v-container>
        </eimza-gate>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../misc';
import EimzaGate from '../../Components/EimzaGate.vue';
import SendersOrMessageTypes from '../../Components/SMSConstants/SendersOrMessageTypes.vue';
import DateMonthPicker from '../../Components/SMSConstants/DateMonthPicker.vue';
import TemplateSelector from '../../Components/SMSConstants/TemplateSelector.vue';
import ButtonKeys from '../../Components/SMSConstants/ButtonKeys.vue';
import SmsMessage from '../../Components/SMSConstants/SmsMessage.vue';
import TimePicker from '../../Components/SMSConstants/TimePicker.vue';
import TimeType from '../../Components/SMSConstants/TimeType.vue';
import SmsConfirmation from '../../Components/SMSConfirmation.vue';
import MessageType from '../../Components/SMSConstants/MessageType.vue';

export default {
  name: 'Index',
  components: {
    EimzaGate,
    SmsConfirmation,
    TimeType,
    TimePicker,
    SmsMessage,
    ButtonKeys,
    TemplateSelector,
    DateMonthPicker,
    SendersOrMessageTypes,
    MessageType,
  },
  data: () => ({
    loading: false,
    types,
    time: '',
    date: '',
    wTimeStat: false,
    dateSelected: false,
    message: '',
    data: { senders: [], groups: [] },
    confirmation: { valid: false, context: { examples: [] } },
    selected: [],
    original: {
      group_id: [],
      message: '',
      sender: '',
      message_type: '',
      run_zone: 'vue',
      message_content_type: null,
    },
  }),
  computed: {
    msgBox: {
      get() { return this.message || ''; },
      set(newVal) { this.message = newVal; },
    },
    allGroups() { return this.selected.length === this.data.groups.length; },
    someGroups() { return this.selected.length > 0 && !this.allGroups; },
    icon() {
      if (this.allGroups) return 'mdi-close-box';
      if (this.someGroups) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  created() {
    this.send({ route: 'sms/group' }).then((res) => {
      if (res.data.data.groups.length === 0) {
        this.$router.push({ name: 'group.contacts.index' }).catch(() => {});
        this.$trigger('set:notification', 'Öncelikle Grup oluşturmanız gerekmektedir.');
      }
      this.data = res.data.data;
      this.setValues();
    });
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    sendMessage() {
      if (this.selected.length > 0 && this.$refs.form.validate()) {
        this.prepareOriginal();
        this.send({ route: 'sms/group/send', data: this.original }).then(() => { this.resetForm(); });
      }
    },
    smsPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.form.validate();
      if (this.selected.length > 0 && this.$refs.form.validate()) {
        this.loading = true;
        this.prepareOriginal();
        this.send({ route: 'sms/group/send/preview', data: this.original })
          .then((res) => { this.confirmation.context = res.data.data; })
          .finally(() => { this.loading = false; });
      }
    },
    prepareOriginal() {
      this.original.group_id = this.selected;
      this.original.message = this.msgBox;
      this.original.send_time = this.date + this.time;
      if (!this.wTimeStat) delete this.original.send_time;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allGroups) {
          this.selected = [];
        } else {
          this.selected = this.data.groups.map(group => group.id);
        }
      });
    },
    setValues() {
      this.senders = this.data.senders;
      // eslint-disable-next-line prefer-destructuring
      this.original.sender = this.senders[0];
      this.original.message_type = this.data.default_message_type;
    },
    resetForm() {
      this.$refs.form.reset();
      this.wTimeStat = false;
      this.setValues();
    },
  },
};
</script>
